import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'
import EventList from '@/components/EventList.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { requiresAuth: true },
    component: Home,
    redirect: { name: 'ManualEvents' },
    children: [
      {
        path: '/events/manual',
        name: 'ManualEvents',
        meta: { requiresAuth: true },
        component: EventList,
        props: {
          namespace: 'manualEvents',
        },
      },
      {
        path: '/events/all',
        name: 'AllEvents',
        meta: { requiresAuth: true },
        component: EventList,
        props: {
          namespace: 'allEvents',
        },
      },
    ],
  },
  {
    path: '/event/create',
    name: 'CreateEvent',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "event" */ '../views/CreateEvent.vue')
  },
  {
    path: '/event/:id',
    name: 'ShowEvent',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "event" */ '../views/ShowEvent.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!store.state.isLoggedInUser) {
      return next({
        name: 'Login',
      });
    }
  } else if (to.name === 'Login') {
    if (store.state.isLoggedInUser) {
      return next({
        name: 'Home'
      });
    }
  }
  next();
});

export default router
